import { render, staticRenderFns } from "./IconShuffle.vue?vue&type=template&id=b71a0d0c"
import script from "./IconShuffle.vue?vue&type=script&lang=js"
export * from "./IconShuffle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports